import React from 'react';
import Bg from '../../images/backgrounds/bg_image_1.webp'
import { Link } from "react-router-dom";

const CtaSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="calltoaction_section parallaxie">
            <div className="container">
                <div className="row">
                <div className='col-lg-12'>
                    <ul className='hero_bottom_stats'>
                        <li>
                            <span className='number_css'>150+</span>
                            <span className='hero_bottom_text'>Satisfied <br/> SEO Clients</span>
                        </li>
                        <li>
                            <span className='number_css'>22+</span>
                            <span className='hero_bottom_text'>Industries <br/> Served</span>
                        </li>
                        <li>
                            <span className='number_css'>117+</span>
                            <span className='hero_bottom_text'>AI Automation <br/> Templates</span>
                        </li>
                    </ul>                
                </div>
            </div>
            </div>
        </section>
    );
}

export default CtaSection;